import MUIDataTable from "mui-datatables";
import { useState, useEffect } from "react";
import "./collectstatus.css";
import { TextField } from "@mui/material";
import { getUserProfile } from "../../../../helpers/profile_helper";
const EasyCollectStatusScreen = ({
  selectedCompany,
  selectedAccount,
  apiService,
}) => {
  let [accountLoadData, setAccountLoadData] = useState([]);
  const [userProfile, setUserProfile] = useState({});
  const [avlblc, setAvlblc] = useState("");
  const [acnumber, setAcnumber] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [btnClicked, setbtnClicked] = useState(false);
  const [collectRef, setcollectRef] = useState("");
  const [colelctData, setPayOutData] = useState("");
  const [is_collect_enabled, setIsCollectEnabled] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (!selectedCompany || !selectedAccount) {
        setAvlblc("");
        setAcnumber("");
        setIfsc("");
        setAccountLoadData([]);
        return;
      }
      setIfsc("Loading ...");
      setAcnumber("Loading ...");
      setAvlblc("Loading ...");
      try {
            var user_profile = await getUserProfile();
              setUserProfile(user_profile);
        var response = await apiService({
          method: "post",
          path: "/user/get_account_details",
          payload: { company: selectedCompany, account: selectedAccount },
        });
        setAvlblc(response.data.balance);
        console.log(response.data.van_stmts);
        setAcnumber(response.data.van.acc_no);
        setIfsc(response.data.van.ifsc);
        console.log('is_collect_enabled : %o', response.data.is_collect_enabled)
        setIsCollectEnabled(response.data.is_collect_enabled);
      } catch (error) {
        localStorage.removeItem("user_profile");
        console.log("%o", error);
      }
    };

    fetchData();
  }, [selectedCompany, selectedAccount]);

  const getPayLoad = async () => {
    try {
      console.log(collectRef);

      var response = await apiService({
        method: "post",
        path: "/user/get_collect_status",
        payload: {
          company: selectedCompany,
          collect_ref_arr: [collectRef.replaceAll(" ", "")],
        },
      });
      console.log(response.data);

      setPayOutData(response.data);
      setcollectRef("");
      setbtnClicked(true);
    } catch (error) {
      localStorage.removeItem("user_profile");
      console.log("%o", error);
    }
  };

  return (
    <div className="Load-easypayouts-load-screen">
      <div className="Load-frame-parent4">

        {/* <div className="Load-card-container">
          <div className="Load-frame-parent5">
            <div className="Load-frame-parent6">
              <div className="Load-vector-container">
                <img className="Load-vector-icon1" alt="" src="/vector.svg" />
              </div>
              <div className="Load-avaliable-balance-group">
                <b className="Load-loads12">Available Balance</b>
                <div className="Load-div20">₹ {avlblc}</div>
              </div>
            </div>
            <div className="Load-cash-stack1" />
          </div>

          <div className="Load-frame-parent5">
            <div className="Load-frame-parent6">
              <div className="Load-vector-container">
                <img className="Load-vector-icon1" alt="" src="/icon1.svg" />
              </div>
              <div className="Load-avaliable-balance-group">
                <b className="Load-loads12">Account Details</b>
                <div className="Load-div16">
                  <span className="Load-acifsc"> Ac.no :</span> {acnumber}
                </div>
                <div className="Load-div16">
                  <span className="Load-acifsc"> IFSC :</span> {ifsc}
                </div>
              </div>
            </div>
            <div className="Load-cash-stack1" />
          </div>
        </div> */}
        {is_collect_enabled && (
          <div className="searchForPayoutStatus">
            <div className="getPayoutStatus">Get Collect status</div>

            <div className="mobileMenuParent">
              <div className="mobileMenu">
                <TextField
                  className="field"
                  color="primary"
                  label="Collect ref"
                  variant="outlined"
                  value={collectRef}
                  onChange={(e) => {
                    setcollectRef(e.target.value);
                  }}
                  placeholder="Enter The Collect Ref"
                  sx={{
                    borderRadius: "22px",
                    "& .MuiInputBase-root": { height: "100%" },
                    width: "100%",
                  }}
                />
                <img className="trailingIcon2" alt="" />
              </div>
              <button
                className="apply"
                onClick={() => {
                  // setcollectRef(collectRef.replaceAll(" ",""));
                  console.log(`this${collectRef.replaceAll(" ", "")}`);

                  getPayLoad();
                }}
              >
                <img className="plusCircleIcon" alt="" src="/pluscircle.svg" />
                <b className="apply1">Search</b>
              </button>
            </div>
          </div>
        )}
        {!is_collect_enabled && (
          <div className={"searchForPayoutStatus"}>
            <div className="getPayoutStatus">Collects Not Enabled on Stack for This Account</div>
          </div>
        )}


        {btnClicked && colelctData && Array.isArray(colelctData) && colelctData.length > 0 ? (
          <div className="collectDetails">
            <div className="payoutStatus">Collect Status</div>
            <div className="collectDetailsInner">
              {colelctData.map((data, dataIndex) => (
                <div key={data.collect_ref || dataIndex} className="frameParent">
                  <div className="frameGroup">
                    <div className="collectRefParent">
                      <div className="collectRef">Collect Reference:</div>
                    </div>
                    <div className="collectRef">
                      {data.collect_ref || "NA"}
                    </div>
                  </div>
                  <div className="frameGroup">
                    <div className="collectRefParent2">
                      <div className="collectRef">Status:</div>
                    </div>
                    <div className={data.status}>
                      {data.status?.toUpperCase() || "NA"}
                    </div>
                  </div>
                  {data.collect_logs && Array.isArray(data.collect_logs) && data.collect_logs.length > 0 ? (
                    data.collect_logs.map((log, logIndex) => (
                      <div key={log.txn_id || logIndex} className="frameParent">
                        {/* <div className="collectRefParent">
                          <div className="collectRef">Collect No :  {logIndex + 1}</div>
                        </div> */}
                        <div className="frameGroup">
                          <div className="collectRefParent">
                            <div className="collectRef">Amount:</div>
                          </div>
                          <div className="collectRef">
                            ₹{log.amount || "NA"}
                          </div>
                        </div>
                        <div className="frameGroup">
                          <div className="collectRefParent">
                            <div className="collectRef">Transaction Status:</div>
                          </div>
                          <div className="collectRef">
                            {log.transaction_status?.toUpperCase() || "NA"}
                          </div>
                        </div>
                              <div className="frameGroup">
                          <div className="collectRefParent">
                            <div className="collectRef">RRN:</div>
                          </div>
                          <div className="collectRef">
                            {log.rrn || "NA"}
                          </div>
                        </div>
                        <div className="frameGroup">
                          <div className="collectRefParent">
                            <div className="collectRef">Payer VPA:</div>
                          </div>
                          <div className="collectRef">
                            {log.payer_vpa || "NA"}
                          </div>
                        </div>
                        <div className="frameGroup">
                          <div className="collectRefParent">
                            <div className="collectRef">Payer Name:</div>
                          </div>
                          <div className="collectRef">
                            {log.payer_verified_name || "NA"}
                          </div>
                        </div>
                        {/* <div className="frameGroup">
                          <div className="collectRefParent">
                            <div className="collectRef">Payee VPA:</div>
                          </div>
                          <div className="collectRef">
                            {log.payee_vpa || "NA"}
                          </div>
                        </div> */}
                        {/* <div className="frameGroup">
                          <div className="collectRefParent">
                            <div className="collectRef">Payee Name:</div>
                          </div>
                          <div className="collectRef">
                            {log.payee_verified_name || "NA"}
                          </div>
                        </div> */}
                        <div className="frameGroup">
                          <div className="collectRefParent">
                            <div className="collectRef">Transaction DateTime:</div>
                          </div>
                          <div className="collectRef">
                            {log.transaction_datetime || "NA"}
                          </div>
                        </div>
                  
                      </div>
                    ))
                  ) : (
                    <div className="frameGroup">
                      <div className="collectRef">No transaction logs available</div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="searchForPayoutStatus">
            <div className="payoutStatus">Collect Status</div>
            <div className="searchForPayoutStatusInner">
              <div className="frameGroup">
                <div className="collectRef">No data available</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default EasyCollectStatusScreen;
